/* eslint max-classes-per-file: 0 */

import { BaseApi } from '@/api/BaseApi'
import { GetNameId } from '@/typings/utils'

import { Module } from 'vuex-smart-module'
import { TransformerParams as ATransformerParams } from './TransformerParams'
import { TransformerData as ATransformerData } from './TransformerData'
import { Adapter as AAdapter } from './Adapter'

import { State as AState } from './State'
import { Getters as AGetters } from './Getters'
import { Mutations as AMutations } from './Mutations'
import { Actions as AActions } from './Actions'


class AdapterExported<T, TT, API extends BaseApi<T, TT>> extends AAdapter<T, TT, API> {
  constructor(
    public readonly api: API,
  ) { super() }
}

export { AdapterExported as Adapter }

export { State } from './State'
export { Actions } from './Actions'

export interface StoreModule<
  T = unknown,
  TT = T,
  S extends AState<T, TT> = AState<T, TT>,
  G extends AGetters<T, TT, S> = AGetters<T, TT, S>,
  M extends AMutations<T, TT, S> = AMutations<T, TT, S>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  A extends AActions<T, TT, S, G, M, A> = AActions<T, TT, S, G, M, any>,
  // @ts-ignore: из-за переопределения модуля
> extends Module<S, G, M, A> {}

export const Fabric = <T, TT>() => {
  class State extends AState<T, TT> {
  }

  class Getters<S extends State> extends AGetters<T, TT, S> {
  }

  class Mutations<S extends State> extends AMutations<T, TT, S> {
  }

  abstract class Actions<
    S extends State,
    G extends Getters<S>,
    M extends Mutations<S>,
    A extends Actions<S, G, M, A>,
  > extends AActions<T, TT, S, G, M, A> {
  }

  class TransformerParams extends ATransformerParams<T, TT> {
  }

  class TransformerData extends ATransformerData<T, TT> {
  }

  abstract class Adapter<API extends BaseApi<T, TT>> extends AAdapter<T, TT, API> {
  }

  return {
    State,
    Getters,
    Mutations,
    Actions,

    TransformerParams,
    TransformerData,
    Adapter,
  }
}

type UseOptionsResult<T, TT, API extends BaseApi<T, TT>> =
  | { idName: GetNameId<T>; api: API }
  | { idName: GetNameId<T>; adapter: AdapterExported<T, TT, API> }

export const Builder = <T, TT, API extends BaseApi<T, TT>>(
  useOptions: () => UseOptionsResult<T, TT, API>,
) => {
  const {
    State,
    Getters,
    Mutations,
    Actions,
    Adapter,
  } = Fabric<T, TT>()

  class AdapterExtends extends Adapter<API> {
    constructor(
      public readonly api: API,
    ) { super() }
  }

  // @ts-ignore TODO: возможно, вы имели в виду "typeof State"
  class ActionsExtends extends Actions<State, Getters, Mutations, Actions> {
    // protected readonly mutations!: Mutations

    public readonly adapter: AdapterExtends;

    constructor(
      public readonly idName: GetNameId<T>,
    ) {
      super()
      const options = useOptions()
      this.idName = options.idName
      this.adapter = 'adapter' in options
        ? options.adapter : new AdapterExtends(options.api)
    }
  }

  const res = new Module({
    state: State,
    getters: Getters,
    mutations: Mutations,
    actions: ActionsExtends,
  })

  return res
}
